import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import session from '../../../../share/session';

/** 
 * DefaultSession遷移
 * @param {object} self this インスタンス
 */
export async function terminate(self) {
  try {
    self.isLoading = true;
    // バックエンドAPI POST,GET
    const token = session.getToken();
    await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'terminate',
      },
      // エラー発生のコールバックを実装
      undefined,
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result, 'terminate'); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result, 'terminate'); },
    );
  } finally {
    self.isLoading = false;
  }
}